import {useState, useEffect, useRef} from 'react';
import * as EdgeApi from '../common/fetch_api/edge';
import {useInterval} from '../common/app_common.js';
import '../common/css/control_site_manager.css';
import {Title} from '../common/component_common.js';
import * as Accepted from './control_site_manager/sites.js';
import * as Pending from './control_site_manager/pending.js';
import * as Rejected from './control_site_manager/rejected.js';
import * as DataEndpoint from './control_site_manager/data_end_point.js';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const getPendingCount = (set) =>
{
    Promise.resolve( EdgeApi.getApiEdgeCount('pending') )
    .then( data => 
    {
        if(data.count != null)
        {
            set(data.count);
        }
    });
}

const ConnectTab = ({tabIndex, setTabIndex, pendingCount}) => {

    // useEffect(() => {
    //     getPendingCount(setPendingCount);
    // }, [update]);

    // useInterval(() =>
    // {
    //     getPendingCount(setPendingCount);
    // }, 10000 );

    return (
        <Tabs
            defaultActiveKey="Sites"
            transition={true}
            activeKey={tabIndex}
            onSelect={(k) => setTabIndex(k)}
            className="mt-3" >
            <Tab eventKey="Sites" title="Sites"/>
            <Tab eventKey="Pending" title={`Pending (${pendingCount})`}/>
            <Tab eventKey="Rejected" title="Rejected"/>
            {/* <Tab eventKey="DataEndpoint" title="DataEndpoint"/> */}
        </Tabs>
    )    
}

const PageControlSiteManager = () => {
    //선택된 탭을 알아야할 때 사용할 수 있는 방법. 현재는 사용하고 있지 않음
    //Tab 선언시 하위에 직접 Component를 넣을 경우 해당 Component를 실행 시켜버리기 때문에 4가지 화면에 필요한 API가 모두 호출되는 문제가 있어 해당 Index와 일치할 때만 불러오도록 수정함
    const [tabIndex, setTabIndex] = useState('Sites');
    const [addEdgeInfo, setAddEdgeInfo] = useState('');
    const [pendingCount, setPendingCount] = useState(0);
    const [update, setUpdate] = useState(false);
    let tickCount = 0;

    function runUpdate()
    {
        setUpdate(!update);
    }

    useEffect(() => {
        getPendingCount(setPendingCount);
    }, [update]);

    useInterval(() =>
    {
        if( tickCount === 20 )
        {
            runUpdate();
            tickCount = 0;
        }

        tickCount++;
    }, 1000 );

    useEffect(() => {
        if(tabIndex!=='Pending')
        {
            setAddEdgeInfo('');
            tickCount = 0;
        }
    }, [tabIndex]);

    return (
        <>
            <Title title={'Site Manager'}></Title>
            <ConnectTab tabIndex={tabIndex} setTabIndex={setTabIndex} pendingCount={pendingCount}></ConnectTab>
            {tabIndex==='Sites'&&<Accepted.View setTabIndex={setTabIndex} setAddEdgeInfo={setAddEdgeInfo} runUpdateTab={update} ></Accepted.View>}
            {tabIndex==='Pending'&&<Pending.View addEdgeInfo={addEdgeInfo} runUpdateTab={update} setUpdateTab={runUpdate}></Pending.View>}
            {tabIndex==='Rejected'&&<Rejected.View runUpdateTab={update} ></Rejected.View>}
            {tabIndex==='DataEndpoint'&&<DataEndpoint.View runUpdateTab={update} ></DataEndpoint.View>}
        </>
    )
}

export default PageControlSiteManager;